import React from 'react';

const TextMessage = ({ details }) => {
  const { message } = details;

  if (!message) return null;

  return <p className='text-sm whitespace-pre-wrap break-words'>{message}</p>;
};

export default TextMessage;
